/* ATTENDANCE */
export const ATTENDANCE_LIST = 'ATTENDANCE_LIST';
export const ATTENDANCE_LIST_SUCCESS = 'ATTENDANCE_LIST_SUCCESS';
export const ATTENDANCE_LIST_FAILED = 'ATTENDANCE_LIST_FAILED';

